export default "__VITE_ASSET__DFNmaYed__"